// Knights One Data - Group One (First 6 Legendary Knights)

// Sir William Marshal's workout programs
const williamMarshalPrograms = [
    {
        id: 'greatest-knight-training',
        name: 'Greatest Knight Training',
        description: 'The legendary tournament champion\'s complete conditioning regimen',
        pattern: '$x&*>=!',
        reps: 12,
        sets: 4,
        focus: 'Tournament Mastery'
    },
    {
        id: 'tournament-champion-conditioning',
        name: 'Tournament Champion Conditioning',
        description: 'Elite combat preparation for the ultimate warrior-knight',
        pattern: '>&$x*+',
        reps: 15,
        sets: 3,
        focus: 'Combat Excellence'
    },
    {
        id: 'royal-protector-protocol',
        name: 'Royal Protector Protocol',
        description: 'Strength training for defending kings and kingdoms',
        pattern: 'xx&&$$',
        reps: 18,
        sets: 4,
        focus: 'Royal Defense'
    },
    {
        id: 'battle-scarred-warrior-workout',
        name: 'Battle-Scarred Warrior Workout',
        description: 'Hardened conditioning from decades of medieval warfare',
        pattern: '*&$>x=',
        reps: 20,
        sets: 3,
        focus: 'Battle Hardened'
    },
    {
        id: 'destrier-rider-strength',
        name: 'Destrier Rider Strength',
        description: 'Mounted combat conditioning for heavy cavalry leadership',
        pattern: '=>{*&$',
        reps: 14,
        sets: 5,
        focus: 'Mounted Combat'
    },
    {
        id: 'marshal-mastery-training',
        name: 'Marshal Mastery Training',
        description: 'The complete regimen that forged the greatest knight who ever lived',
        pattern: '$&x*>=!!',
        reps: 22,
        sets: 3,
        focus: 'Legendary Mastery'
    }
];

// Sir Lancelot du Lac's workout programs
const lancelotPrograms = [
    {
        id: 'perfect-knight-training',
        name: 'Perfect Knight Training',
        description: 'Pristine conditioning that embodies knightly perfection',
        pattern: '>$&x*+',
        reps: 16,
        sets: 4,
        focus: 'Knightly Perfection'
    },
    {
        id: 'arondight-wielder-conditioning',
        name: 'Arondight Wielder Conditioning',
        description: 'Legendary sword mastery through superior physical preparation',
        pattern: 'x*&$>+',
        reps: 19,
        sets: 3,
        focus: 'Sword Mastery'
    },
    {
        id: 'courtly-grace-strength',
        name: 'Courtly Grace Strength',
        description: 'Elegant power that combines beauty with devastating effectiveness',
        pattern: '&>$*x=',
        reps: 13,
        sets: 5,
        focus: 'Graceful Power'
    },
    {
        id: 'queen-champion-protocol',
        name: 'Queen\'s Champion Protocol',
        description: 'Elite training for the greatest champion of Camelot',
        pattern: '*$&x>+',
        reps: 17,
        sets: 4,
        focus: 'Champion Excellence'
    },
    {
        id: 'white-knight-conditioning',
        name: 'White Knight Conditioning',
        description: 'Pure strength training that maintains moral and physical superiority',
        pattern: '>>&**$$',
        reps: 21,
        sets: 3,
        focus: 'Pure Strength'
    },
    {
        id: 'lancelot-legend-mastery',
        name: 'Lancelot Legend Mastery',
        description: 'The ultimate training that created the most famous knight of all time',
        pattern: '$x&*>+!!',
        reps: 25,
        sets: 3,
        focus: 'Legendary Fame'
    }
];

// Sir Gawain of Orkney's workout programs
const gawainPrograms = [
    {
        id: 'solar-strength-training',
        name: 'Solar Strength Training',
        description: 'Power that waxes with the sun, building unstoppable momentum',
        pattern: '&*$x>=',
        reps: 11,
        sets: 6,
        focus: 'Solar Power'
    },
    {
        id: 'galatine-fire-conditioning',
        name: 'Galatine Fire Conditioning',
        description: 'Burning intensity that channels the power of the sun sword',
        pattern: '>*&$x+',
        reps: 18,
        sets: 4,
        focus: 'Solar Fire'
    },
    {
        id: 'orkney-warrior-protocol',
        name: 'Orkney Warrior Protocol',
        description: 'Northern island strength forged in harsh coastal conditions',
        pattern: 'x&>$*=',
        reps: 15,
        sets: 4,
        focus: 'Northern Strength'
    },
    {
        id: 'arthur-nephew-training',
        name: 'Arthur\'s Nephew Training',
        description: 'Royal bloodline conditioning worthy of Pendragon heritage',
        pattern: '$>x&*+',
        reps: 14,
        sets: 5,
        focus: 'Royal Heritage'
    },
    {
        id: 'bronze-mail-strength',
        name: 'Bronze Mail Strength',
        description: 'Gleaming armor conditioning that catches and reflects power',
        pattern: '&&$$>>',
        reps: 20,
        sets: 3,
        focus: 'Gleaming Power'
    },
    {
        id: 'pentangle-mastery-training',
        name: 'Pentangle Mastery Training',
        description: 'Five-pointed perfection representing the complete knight-warrior',
        pattern: '&$x*>+!!',
        reps: 23,
        sets: 3,
        focus: 'Five-Point Mastery'
    }
];

// Sir Galahad the Pure's workout programs
const galahadPrograms = [
    {
        id: 'grail-knight-training',
        name: 'Grail Knight Training',
        description: 'Sacred conditioning for the purest of all knights',
        pattern: '>+&*$x',
        reps: 12,
        sets: 7,
        focus: 'Sacred Purity'
    },
    {
        id: 'spiritual-light-conditioning',
        name: 'Spiritual Light Conditioning',
        description: 'Divine strength that radiates from perfect inner harmony',
        pattern: '+$&>*x',
        reps: 9,
        sets: 8,
        focus: 'Divine Light'
    },
    {
        id: 'silver-mail-protocol',
        name: 'Silver Mail Protocol',
        description: 'Armor conditioning that seems to glow with inner light',
        pattern: 'x*>+&$',
        reps: 16,
        sets: 4,
        focus: 'Inner Glow'
    },
    {
        id: 'christ-cross-training',
        name: 'Christ Cross Training',
        description: 'Sacred symbol strength for the bearer of divine favor',
        pattern: '&>$+*x',
        reps: 13,
        sets: 5,
        focus: 'Divine Favor'
    },
    {
        id: 'perfect-balance-strength',
        name: 'Perfect Balance Strength',
        description: 'Harmonious conditioning that achieves spiritual and physical perfection',
        pattern: '++=>>&&',
        reps: 17,
        sets: 4,
        focus: 'Perfect Harmony'
    },
    {
        id: 'grail-achievement-mastery',
        name: 'Grail Achievement Mastery',
        description: 'The ultimate training that enables the impossible - achieving the Holy Grail',
        pattern: '>+&*$x!!',
        reps: 21,
        sets: 3,
        focus: 'Grail Mastery'
    }
];

// Sir Gareth of Orkney's workout programs
const garethPrograms = [
    {
        id: 'youngest-knight-training',
        name: 'Youngest Knight Training',
        description: 'Eager conditioning that burns with youthful knightly enthusiasm',
        pattern: '*>&$x+',
        reps: 10,
        sets: 6,
        focus: 'Youthful Fire'
    },
    {
        id: 'courteous-warrior-conditioning',
        name: 'Courteous Warrior Conditioning',
        description: 'Perfect manners combined with devastating combat effectiveness',
        pattern: '&$*>x+',
        reps: 14,
        sets: 4,
        focus: 'Courteous Power'
    },
    {
        id: 'peacock-feather-protocol',
        name: 'Peacock Feather Protocol',
        description: 'Colorful training that displays magnificent knightly prowess',
        pattern: '>x&$*+',
        reps: 16,
        sets: 4,
        focus: 'Magnificent Display'
    },
    {
        id: 'red-rose-strength',
        name: 'Red Rose Strength',
        description: 'Vibrant conditioning that blooms with chivalric excellence',
        pattern: '$*&>x+',
        reps: 12,
        sets: 5,
        focus: 'Chivalric Bloom'
    },
    {
        id: 'chestnut-destrier-training',
        name: 'Chestnut Destrier Training',
        description: 'Spirited mounted conditioning for the most enthusiastic knight',
        pattern: '>>$$**',
        reps: 18,
        sets: 3,
        focus: 'Spirited Enthusiasm'
    },
    {
        id: 'golden-potential-mastery',
        name: 'Golden Potential Mastery',
        description: 'Training that develops the unlimited promise of knightly youth',
        pattern: '*>&$x+!!',
        reps: 20,
        sets: 3,
        focus: 'Unlimited Promise'
    }
];

// Sir Percival the Welsh's workout programs
const percivalPrograms = [
    {
        id: 'welsh-grail-training',
        name: 'Welsh Grail Training',
        description: 'Celtic mysticism combined with Grail quest conditioning',
        pattern: '+>$&*x',
        reps: 11,
        sets: 7,
        focus: 'Celtic Mysticism'
    },
    {
        id: 'purple-knight-conditioning',
        name: 'Purple Knight Conditioning',
        description: 'Royal color strength that embodies ancient Welsh nobility',
        pattern: '>&+$*x',
        reps: 15,
        sets: 4,
        focus: 'Welsh Nobility'
    },
    {
        id: 'silver-chalice-protocol',
        name: 'Silver Chalice Protocol',
        description: 'Sacred vessel training for the mystical Grail knight',
        pattern: 'x+>&$*',
        reps: 13,
        sets: 5,
        focus: 'Sacred Vessel'
    },
    {
        id: 'celtic-knot-strength',
        name: 'Celtic Knot Strength',
        description: 'Interwoven conditioning patterns from ancient Welsh traditions',
        pattern: '$>&+*x',
        reps: 17,
        sets: 4,
        focus: 'Ancient Tradition'
    },
    {
        id: 'welsh-cob-training',
        name: 'Welsh Cob Training',
        description: 'Hardy mountain conditioning for spiritual quest endurance',
        pattern: '++>>$$',
        reps: 19,
        sets: 3,
        focus: 'Quest Endurance'
    },
    {
        id: 'mystical-mastery-training',
        name: 'Mystical Mastery Training',
        description: 'The complete Welsh knight training that bridges earthly and divine realms',
        pattern: '+>$&*x!!',
        reps: 24,
        sets: 3,
        focus: 'Divine Bridge'
    }
];

// Main Knights One trainers data object - Group One
const knightsOneTrainersData = {
    'sir-william-marshal-1st-earl-of-pembroke': {
        id: 'sir-william-marshal-1st-earl-of-pembroke',
        name: 'Sir William Marshal',
        title: '1st Earl of Pembroke',
        specialization: 'Tournament Champion & Royal Protector',
        image: '/assets/images/Sir-William-Marshal-1st-Earl-of-Pembroke.jpg',
        experience: '50+ years',
        category: 'knights-one',
        color: '#C0C0C0',
        secondaryColor: '#4169E1',
        intro: `Known as "the greatest knight who ever lived," Sir William Marshal dominated tournaments across Europe and served five English kings with unwavering loyalty. His training philosophy emphasizes that true strength comes from honor, discipline, and the courage to face any opponent. Through tournament conditioning, he teaches that every battle is won before it begins - through superior preparation and unshakeable resolve.`,
        programs: williamMarshalPrograms
    },
    'sir-lancelot-du-lac': {
        id: 'sir-lancelot-du-lac',
        name: 'Sir Lancelot du Lac',
        title: 'The Perfect Knight',
        specialization: 'Sword Mastery & Courtly Excellence',
        image: '/assets/images/Sir-Lancelot-du-Lac.jpg',
        experience: '40+ years',
        category: 'knights-one',
        color: '#FFFFFF',
        secondaryColor: '#DC143C',
        intro: `The most renowned knight of the Round Table, Lancelot embodies the perfect balance of martial prowess and courtly grace. His legendary sword Arondight never knew defeat, and his training methods focus on achieving flawless technique through relentless practice. Students learn that true knightly strength comes from the harmony of body, mind, and noble spirit.`,
        programs: lancelotPrograms
    },
    'sir-gawain-of-orkney': {
        id: 'sir-gawain-of-orkney',
        name: 'Sir Gawain of Orkney',
        title: 'Knight of the Solar Strength',
        specialization: 'Solar-Powered Combat & Northern Warfare',
        image: '/assets/images/Sir-Gawain-of-Orkney.jpg',
        experience: '45+ years',
        category: 'knights-one',
        color: '#CD7F32',
        secondaryColor: '#FFD700',
        intro: `Arthur's nephew possesses the legendary gift of solar strength - his power waxes and wanes with the sun. His bronze mail catches sunlight like captured fire, and his sword Galatine glows with solar energy. His training teaches students to harness natural rhythms and channel the raw power of nature into devastating combat effectiveness.`,
        programs: gawainPrograms
    },
    'sir-galahad-the-pure': {
        id: 'sir-galahad-the-pure',
        name: 'Sir Galahad the Pure',
        title: 'The Grail Knight',
        specialization: 'Sacred Combat & Spiritual Perfection',
        image: '/assets/images/Sir-Galahad-the-Pure.jpg',
        experience: '25+ years',
        category: 'knights-one',
        color: '#E6E6FA',
        secondaryColor: '#8B0000',
        intro: `The only knight pure enough to achieve the Holy Grail, Galahad radiates divine light and spiritual power. His silver mail seems to glow from within, and his very presence sanctifies the battlefield. His training emphasizes that physical strength must be matched by spiritual purity - only through perfect balance can one achieve the impossible.`,
        programs: galahadPrograms
    },
    'sir-gareth-of-orkney': {
        id: 'sir-gareth-of-orkney',
        name: 'Sir Gareth of Orkney',
        title: 'The Courteous Knight',
        specialization: 'Youthful Excellence & Chivalric Training',
        image: '/assets/images/Sir-Gareth-of-Orkney.jpg',
        experience: '20+ years',
        category: 'knights-one',
        color: '#FFD700',
        secondaryColor: '#DC143C',
        intro: `The youngest of Gawain's brothers, Gareth burns with eager enthusiasm and perfect courtesy. His bright yellow surcoat decorated with red roses displays his vibrant spirit, while his peacock-feathered helm shows his pride in knightly achievement. His training proves that youth, when properly directed, can achieve greatness beyond measure.`,
        programs: garethPrograms
    },
    'sir-percival-the-welsh': {
        id: 'sir-percival-the-welsh',
        name: 'Sir Percival the Welsh',
        title: 'The Mystic Grail Knight',
        specialization: 'Celtic Warfare & Spiritual Questing',
        image: '/assets/images/Sir-Percival-the-Welsh.jpg',
        experience: '35+ years',
        category: 'knights-one',
        color: '#800080',
        secondaryColor: '#C0C0C0',
        intro: `The Welsh Grail knight brings ancient Celtic mysticism to the Round Table. His purple surcoat with silver Celtic knotwork reflects his connection to older, deeper traditions. His training combines the practical warfare of the Welsh mountains with the spiritual discipline needed for the Grail quest - teaching that true strength comes from understanding both earth and heaven.`,
        programs: percivalPrograms
    }
};

// Export the data
export default knightsOneTrainersData;